// extracted by mini-css-extract-plugin
export default {"logos":"logos_logos__yuemQ","logo":"logos_logo__382lc"};